export type LookInsidePage = {
  /** Page image. Empty = branded placeholder tile until the Volume 1 renders are ready. */
  src: string
  caption: string
  /** Used by the placeholder tile. */
  label: string
}

export const lookInsidePages: LookInsidePage[] = [
  {
    src: '',
    label: 'Vol. 1 · Cover',
    caption: 'The cover: Volume 1, Start Strong',
  },
  {
    src: '',
    label: 'Vol. 1 · p. 5',
    caption: 'The Flex-Level Class Method, on one page',
  },
  {
    src: '',
    label: 'Vol. 1 · p. 8',
    caption: 'Week 1 Class Plan: the whole class at a glance',
  },
  {
    src: '',
    label: 'Vol. 1 · p. 10',
    caption: 'Week 1 Combo Card: "Hello Groove" in three levels',
  },
  {
    src: '',
    label: 'Vol. 1 · p. 50',
    caption: 'The whole volume on one Field Card',
  },
]
